import {
  addDays,
  addMonths,
  addYears,
  endOfDay,
  endOfMonth,
  endOfWeek,
  endOfYear,
  startOfDay,
  startOfMonth,
  startOfWeek,
  startOfYear,
} from 'date-fns';
import { DefinedRange, Range, createStaticRanges } from 'react-date-range';

const rangeFilters = {
  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),
  startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
  endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
  startOfToday: startOfDay(new Date()),
  startOfLastSevenDay: startOfDay(addDays(new Date(), -7)),
  startOfLastThirtyDay: startOfDay(addDays(new Date(), -30)),
  startOfLastNintyDay: startOfDay(addDays(new Date(), -90)),
  endOfToday: endOfDay(new Date()),
  startOfYesterday: startOfDay(addDays(new Date(), -1)),
  endOfYesterday: endOfDay(addDays(new Date(), -1)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
  startOfYear: startOfYear(new Date()),
  endOfYear: endOfYear(new Date()),
  startOflastYear: startOfYear(addYears(new Date(), -1)),
  endOflastYear: endOfYear(addYears(new Date(), -1)),
};

const staticRangesTemplate = [
  {
    label: 'Hoje',
    range: {
      startDate: rangeFilters.startOfToday,
      endDate: rangeFilters.endOfToday,
    },
  },
  {
    label: 'Últimos 7 dias',
    range: {
      startDate: rangeFilters.startOfLastSevenDay,
      endDate: rangeFilters.endOfToday,
    },
  },
  {
    label: 'Últimos 30 dias',
    range: {
      startDate: rangeFilters.startOfLastThirtyDay,
      endDate: rangeFilters.endOfToday,
    },
  },
  {
    label: 'Últimos 90 dias',
    range: {
      startDate: rangeFilters.startOfLastNintyDay,
      endDate: rangeFilters.endOfToday,
    },
  },
  {
    label: 'Semana corrente',
    range: {
      startDate: rangeFilters.startOfWeek,
      endDate: rangeFilters.endOfWeek,
    },
  },
  {
    label: 'Semana passada',
    range: {
      startDate: rangeFilters.startOfLastWeek,
      endDate: rangeFilters.endOfLastWeek,
    },
  },
  {
    label: 'Mês corrente',
    range: {
      startDate: rangeFilters.startOfMonth,
      endDate: rangeFilters.endOfMonth,
    },
  },
  {
    label: 'Mês passado',
    range: {
      startDate: rangeFilters.startOfLastMonth,
      endDate: rangeFilters.endOfLastMonth,
    },
  },
  {
    label: 'Ano corrent',
    range: {
      startDate: rangeFilters.startOfYear,
      endDate: rangeFilters.endOfYear,
    },
  },
  {
    label: 'Ano passado',
    range: {
      startDate: rangeFilters.startOflastYear,
      endDate: rangeFilters.endOflastYear,
    },
  },
];

function verifyIfIsSelected(currentRange: Range, expectedRange: Range) {
  return (
    currentRange.startDate === expectedRange.startDate &&
    currentRange.endDate === expectedRange.endDate
  );
}

function staticRangeFactory({ label, range }: { label: string; range: Range }) {
  return {
    label: label,
    range: () => range,
    isSelected(currRange: Range) {
      return verifyIfIsSelected(currRange, {
        startDate: range.startDate,
        endDate: range.endDate,
      });
    },
  };
}

const staticRanges = staticRangesTemplate.map((staticRange) =>
  staticRangeFactory(staticRange)
);

interface StaticDateRangeProps {
  dateRange: Range;
  onChange: (range: Range) => void;
}

export function StaticDateRange({ dateRange, onChange }: StaticDateRangeProps) {
  return (
    <DefinedRange
      onChange={(item) => onChange(item.range1)}
      ranges={[dateRange]}
      staticRanges={createStaticRanges(staticRanges)}
      inputRanges={[]}
    />
  );
}
